import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store/index'

import Index from '../views/app/Index'
import Tutorial from '../views/app/Tutorial'
import Penalty from '../components/home/Penalty'

import Start from '../views/app/Start'
import Pending from '../views/app/Pending'
import Invited from '../views/app/Invited'
import Division from '../views/app/Division'

import Main from '../views/app/Main'

import Home from '../views/main/Home'
import Calendar from '../views/main/Calendar'
import History from '../views/main/History'
import Config from '../views/main/Config'

import Diary from '../views/diary/Diary'
import DiaryWrite from '../components/calendar/DiaryWrite'
import DiaryDetail from '../components/calendar/DiaryDetail'

import Policy from '../components/config/Policy'
import Terms from '../components/config/Terms'

import KakaoLogin from '../views/auth/KakaoLogin'
import AppleLogin from '../views/auth/AppleLogin'

import Logout from '../views/auth/Logout'

import Error from '../views/Error'


import axios from 'axios'

Vue.use(VueRouter)

const requireAuth = () => (to, from, next) => {
  var logon = store.getters.login;
  if (logon) {
    return next();
  }
  next('/');
};

const unrequireAuth = () => (to, from, next) => {
  // var dev = window.location.hostname === 'localhost';
  var logon = store.getters.login;
  if (logon) {
    return next('/division');
  } else {
    return next();
  }
};


const routes = [
  {
    path: '/',
    name: 'Index',
    // beforeEnter: unrequireAuth(),
    component: Index
  },
  {
    path: '/error',
    name: 'Error',
    component: Error
  },
  {
    path: '/logout',
    name: 'Logout',
    // beforeEnter: requireAuth(),
    component: Logout
  },
  {
    path: '/tutorial',
    // beforeEnter: requireAuth(),
    name: 'Tutorial',
    component: Tutorial
  },
  {
    path: '/start',
    name: 'Start',
    // beforeEnter: requireAuth(),
    component: Start
  },
  {
    path: '/pending',
    name: 'Pending',
    // beforeEnter: requireAuth(),
    component: Pending
  },
  {
    path: '/invited',
    name: 'Invited',
    component: Invited
  },
  {
    path: '/division',
    name: 'Division',
    component: Division
  },
  {
    path: '/penalty',
    name: 'Penalty',
    component: Penalty
  },
  {
    path: '/',
    name: 'Main',
    component: Main,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home
      },
      {
        path: 'history',
        name: 'History',
        component: History
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'config',
        name: 'Config',
        component: Config
      },
    ]
  },
  {
    path: "/diary",
    name: "Diary",
    component: Diary,
    children: [
      {
        path: 'write',
        name: 'DiaryWrite',
        component: DiaryWrite
      },
      {
        path: 'detail',
        name: 'DiaryDetail',
        component: DiaryDetail
      },
    ]
  },
  {
    path: "/policy",
    name: 'Policy',
    component: Policy,
  },
  {
    path: "/terms",
    name: 'Terms',
    component: Terms,
  },

  {
    path: "/social/kakao",
    name: "KakaoLogin",
    component: KakaoLogin
  },
  {
    path: "/social/apple",
    name: "AppleLogin",
    component: AppleLogin
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
});

// function setPushToken(t) {
//   axios.post('/users/tokens', { token: t }).then(response => {
//     // if (response.data === true) {
//     //   window.localStorage.removeItem('pushToken');
//     // }
//   }).catch((error) => {
//     return false;
//   });
// }

// router.beforeEach(async (to, from, next) => {
//   console.log(from.path, ' -> ', to.path)
//   if (to.path == '/') {
//     return next();
//   } else {
//     var pushToken = window.localStorage.getItem('pushToken');
//     await store.dispatch('userInfoSync', {});
//     await store.dispatch('challenge', {});

//     if (pushToken) {
//       await setPushToken(pushToken);
//     }

//     await store.dispatch('getNotification', { body: { challengeId: store.getters.challengeId } });

//     await next();
//   }
// });

export default router
